// Auto-extracted tab: attestations
import React, { useState, useEffect, useMemo, useCallback } from 'react';

/**
 * AttestationsTab - extracted from app.jsx
 * Original lines: 10767-10835
 * 
 * TODO: This component needs props passed from AppContent:
 * - darkMode, scenarios, thresholds, etc.
 * - All the state and handlers it uses
 */
export function AttestationsTab(props) {
  // Original render content (needs refactoring to use props):
  return (
    <>
          <div className="space-y-6">
            {/* Phase 2: Attestation Readiness Panel */}
            <AttestationReadinessPanel 
              readiness={attestationReadiness}
              onViewBlocker={(item) => {
                setEqDetailModal({ open: true, item: item.item, type: item.type.toLowerCase() });
              }}
              onStartAttest={() => setAttestModal(true)}
            />
            
            {/* Attestation History */}
            <Card darkMode={darkMode} title="Attestation History" subtitle={`${attestations.length} attestation${attestations.length !== 1 ? "s" : ""} on record`}>
              <div className="overflow-x-auto rounded-xl border border-slate-200/50">
                <table className="w-full text-sm">
                  <thead className="bg-gradient-to-r from-slate-50 to-slate-100/80">
                    <tr>
                      <th className="px-4 py-3.5 text-left font-semibold text-slate-700">Period</th>
                      <th className="px-4 py-3.5 text-left font-semibold text-slate-700">Attested</th>
                    <th className="px-3 py-2 text-left font-medium text-slate-600">Scenarios</th>
                    <th className="px-3 py-2 text-left font-medium text-slate-600">Thresholds</th>
                    <th className="px-3 py-2 text-left font-medium text-slate-600">Status</th>
                    <th className="px-3 py-2 text-left font-medium text-slate-600">Receipt</th>
                  </tr></thead>
                  <tbody className="divide-y divide-slate-100">
                    {dataLoading && attestations.length === 0 ? (
                      <tr><td colSpan={6} className="px-4 py-16">
                        <div className="flex flex-col items-center justify-center">
                          <Icons.Refresh className="w-8 h-8 text-emerald-500 animate-spin mb-3" />
                          <div className="text-slate-600 font-medium">Loading attestations...</div>
                        </div>
                      </td></tr>
                    ) : attestations.length === 0 ? (
                      <tr><td colSpan={6} className="px-4 py-16">
                        <div className="flex flex-col items-center justify-center text-center">
                          <div className="w-16 h-16 rounded-2xl bg-gradient-to-br from-emerald-100 to-green-100 flex items-center justify-center mb-4">
                            <Icons.Check className="w-8 h-8 text-emerald-500" />
                          </div>
                          <h3 className="text-lg font-semibold text-slate-900 mb-2">No attestations yet</h3>
                          <p className="text-slate-500 mb-6 max-w-sm">Complete your first attestation ceremony to certify your governance documentation.</p>
                          <Button variant="primary" onClick={() => setAttestModal(true)}>
                            <Icons.Check className="w-4 h-4 mr-2" /> Start Attestation
                          </Button>
                        </div>
                      </td></tr>
                    ) : attestations.map(a => (
                      <tr key={a.id} className="hover:bg-slate-50">
                        <td className="px-3 py-3 font-medium text-slate-900">{formatDate(a.period_month)}</td>
                        <td className="px-3 py-3 text-slate-500">{formatDateTime(a.attested_at)}</td>
                        <td className="px-3 py-3 text-slate-500">{a.scenario_count}</td>
                        <td className="px-3 py-3 text-slate-500">{a.threshold_count}</td>
                        <td className="px-3 py-3"><Badge color={a.eq_pass ? "emerald" : "amber"}>{a.eq_pass ? "Passed" : "With Overrides"}</Badge></td>
                        <td className="px-3 py-3">
                          {a.receipt_path ? (
                            <Button variant="ghost" size="sm" onClick={() => downloadReceipt(a)} disabled={downloadingReceipt === a.id}>
                              {downloadingReceipt === a.id ? <Icons.Clock className="animate-spin" /> : <Icons.Download />} PDF
                            </Button>
                          ) : (
                            <span className="text-xs text-slate-500">—</span>
                          )}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </Card>
          </div>
    </>
  );
}

export default AttestationsTab;
